<template>
  <div>
    <h3 class="text-lg font-semibold gap-2">{{ title }}</h3>
    <p class="text-sm secondary_color">
      {{ description }}
    </p>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
});
</script>
